import { LazyFeature, PageUnstyled, } from '@office-start/office-home-app-shared';
import React, { lazy } from 'react';
import { appbarConnectorService } from '../AppHostPage/AppHostPage';
var MyContentLazy = lazy(function () {
    return import(
    /* webpackChunkName: "my-content" */ '@office-start/my-content-component');
});
var appClickCallback = function (clickTime, isAppRunning) {
    appbarConnectorService.onAppButtonClick(clickTime, isAppRunning);
};
export var MyContentPage = function (scrollContentRef, defaultPivot) {
    var MyContentInternal = function () {
        return (React.createElement(PageUnstyled, { name: "MyContent" },
            React.createElement(LazyFeature, null,
                React.createElement(MyContentLazy, { scrollContentRef: scrollContentRef, disableFullHeightContainer: true, defaultPivot: defaultPivot, setAppClickTime: appClickCallback }))));
    };
    return MyContentInternal;
};
//# sourceMappingURL=MyContentPage.js.map